export const sizeVariantMap = {
  large: 'button1',
  small: 'button2',
  xsmall: 'button3',
} as const;

export type Size = keyof typeof sizeVariantMap;
export type Variant = (typeof sizeVariantMap)[Size];
